<section class="category-collection">
  <header *ngIf="title" class="category-collection__header">
    <h1 class="vtmn-title-4">{{ title }}</h1>

    <ng-container *ngTemplateOutlet="navigation"></ng-container>
  </header>

  <ng-container *ngIf="!title">
    <div
      class="category-collection__header category-collection__header--nav-only"
    >
      <ng-container *ngTemplateOutlet="navigation"></ng-container>
    </div>
  </ng-container>

  <swiper [virtual]="true" [config]="config">
    <ng-container *ngFor="let category of categories; let i = index">
      <ng-template swiperSlide>
        <a
          *ngIf="!category.external_link"
          [routerLink]="getLink(category.link)"
          [queryParams]="getQuery(category.link)"
          [attr.aria-label]="category.title"
        >
          <ng-container *ngTemplateOutlet="attendeeCategory"></ng-container>
        </a>

        <a
          *ngIf="category.external_link"
          [href]="category.external_link"
          [attr.target]="category.open_in_new_tab ? '_blank' : null"
          [attr.rel]="category.open_in_new_tab ? 'noopener noreferrer' : null"
          [attr.aria-label]="category.title"
        >
          <ng-container *ngTemplateOutlet="attendeeCategory"></ng-container>
        </a>

        <ng-template #attendeeCategory>
          <app-attendee-category
            [image]="getPicture(category)"
            [title]="category.title"
            [description]="category.description"
          >
          </app-attendee-category>
        </ng-template>
      </ng-template>
    </ng-container>
  </swiper>

  <ng-template #navigation>
    <div class="category-collection__navigation">
      <button
        [id]="prevCategoryCollectionButtonId"
        app-vtmn-play-icon-button
        type="button"
        class="category-collection__navigation__button mr-2"
        [size]="vtmnPlayIconButtonSize.MEDIUM"
        [variant]="vtmnPlayButtonIconVariant.SECONDARY"
        [attr.aria-label]="'a11y.slider.button.next' | translate"
      >
        <vtmn-play-icon [name]="icon?.ArrowLeft"></vtmn-play-icon>
      </button>
      <button
        [id]="nextCategoryCollectionButtonId"
        app-vtmn-play-icon-button
        type="button"
        class="category-collection__navigation__button mr-2"
        [size]="vtmnPlayIconButtonSize.MEDIUM"
        [variant]="vtmnPlayButtonIconVariant.SECONDARY"
        [attr.aria-label]="'a11y.slider.button.next' | translate"
      >
        <vtmn-play-icon [name]="icon?.ArrowRight"></vtmn-play-icon>
      </button>
    </div>
  </ng-template>
</section>
